import React from 'react';
import { Link } from 'gatsby';
import {
  Hits,
  Index,
} from 'react-instantsearch-dom';

import CDNImage from '../common/cdn-image';

const HitsInIndex = ({ index, format }) => (
  <Index indexName={ index.name }>
    <Hits className="Hits" hitComponent={ PageHit } />
  </Index>
);

const PageHit = ({ hit }) => {
  return (
    <li>
      <Link to={`/product/${hit.reference}`}>
        <div className="image">
          <CDNImage imagePath={hit.imageFilePath} width={80} />
        </div>
        <div className="contents">
          <div
            className="name"
            dangerouslySetInnerHTML={{ __html: hit.name }}
          />
          <div className="category">{hit.productCategory}</div>
        </div>
      </Link>
    </li>
  );
}

const ShopSearchResult = ({ indices }) => {
  return (
    <ul>
      {indices.map(index => (
        <HitsInIndex index={index} key={index.name} />
      ))}
    </ul>
  );
};

export default ShopSearchResult;
